var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 17.0312C2.625 17.4004 2.91211 17.6875 3.28125 17.6875H19.6875C20.3848 17.6875 21 18.3027 21 19C21 19.7383 20.3848 20.3125 19.6875 20.3125H3.28125C1.43555 20.3125 0 18.877 0 17.0312V3.25C0 2.55273 0.574219 1.9375 1.3125 1.9375C2.00977 1.9375 2.625 2.55273 2.625 3.25V17.0312ZM14.0273 12.0684C13.5352 12.6016 12.6738 12.6016 12.1816 12.0684L9.84375 9.73047L6.15234 13.3809C5.66016 13.9141 4.79883 13.9141 4.30664 13.3809C3.77344 12.8887 3.77344 12.0273 4.30664 11.5352L8.90039 6.94141C9.39258 6.4082 10.2539 6.4082 10.7461 6.94141L13.125 9.2793L17.4316 4.97266C17.9238 4.43945 18.7852 4.43945 19.2773 4.97266C19.8105 5.46484 19.8105 6.32617 19.2773 6.81836L14.0273 12.0684Z",
    fill: "#13C1BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96875 16.3594C3.96875 16.9336 4.37891 17.3438 4.95312 17.3438H22.0156C22.5488 17.3438 23 17.7949 23 18.3281C23 18.9023 22.5488 19.3125 22.0156 19.3125H4.95312C3.3125 19.3125 2 18 2 16.3594V1.92188C2 1.38867 2.41016 0.9375 2.98438 0.9375C3.51758 0.9375 3.96875 1.38867 3.96875 1.92188V16.3594ZM15.7812 12.1348C15.4121 12.5449 14.7969 12.5449 14.4277 12.1348L11.1465 8.89453L7.90625 12.1348C7.53711 12.5449 6.92188 12.5449 6.55273 12.1348C6.14258 11.7656 6.14258 11.1504 6.55273 10.7402L10.4902 6.80273C10.6543 6.63867 10.9004 6.51562 11.1465 6.51562C11.4336 6.51562 11.6797 6.63867 11.8438 6.80273L15.125 10.084L20.0059 5.16211C20.375 4.79297 20.9902 4.79297 21.3594 5.16211C21.7695 5.57227 21.7695 6.1875 21.3594 6.55664L15.7812 12.1348Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgChart);
export default __webpack_public_path__ + "static/media/img_chart.c6f273602a0fddda0833785c19a1fc0d.svg";
export { ForwardRef as ReactComponent };